import {
  type CanvasElementFrom,
  type PartialPropsOf,
  type WidthSettings,
} from '@blaze-runtime/engine-domain';
import { isEqual } from '@blaze-shared/shared-util';

import { migrateFontBoldStyleToFontWeightMutably } from '../../../../services/compat/migration.helpers';
import { type LayoutMigration } from '../../../../services/compat/migrations/layout-migration.models';
import { migrateLegacyNavMenuItemsMutably } from '../../../../services/nav-menu-items.service';

export const navMenuV2Migration: LayoutMigration = {
  mode: 'layout',
  description: 'Nav Menu Migration V2 - Updating width settings and submenu styles',
  run: (element: CanvasElementFrom<'navMenu'>): void => {
    // Size - BL-3452
    const legacyInitialValue: WidthSettings = { mode: 'auto', value: 160, fixed: false };
    if (isEqual(element.width, legacyInitialValue)) {
      // If the element still has the legacy initial values, update them to new ones for consistent appearance
      element.width.mode = 'value';
      element.width.value = 188;
    }
    const props = element.props;
    const navMenuProps = props as PartialPropsOf<'navMenu'> | undefined;
    if (navMenuProps) {
      // Initialize object to be copied
      if (
        (navMenuProps.style?.default ||
          navMenuProps.style?.hover ||
          navMenuProps.style?.active ||
          navMenuProps.style?.outline) &&
        !navMenuProps.style?.submenu
      ) {
        navMenuProps.style = {
          ...navMenuProps.style,
          submenu: {},
        };
      }

      // Copy missing colors. Used for new nav menu templates backward compatibility - BL-5420
      if (navMenuProps.style?.submenu) {
        if (!navMenuProps.style?.submenu?.default && navMenuProps.style?.default) {
          navMenuProps.style.submenu.default = { ...navMenuProps.style.default };
        }
        if (!navMenuProps.style?.submenu?.hover && navMenuProps.style?.hover) {
          navMenuProps.style.submenu.hover = { ...navMenuProps.style.hover };
        }
        if (!navMenuProps.style?.submenu?.active && navMenuProps.style?.active) {
          navMenuProps.style.submenu.active = { ...navMenuProps.style.active };
        }
        if (!navMenuProps.style?.submenu?.outline && navMenuProps.style?.outline) {
          navMenuProps.style.submenu.outline = { ...navMenuProps.style.outline };
        }
      }

      migrateLegacyNavMenuItemsMutably(navMenuProps);

      migrateFontBoldStyleToFontWeightMutably(navMenuProps?.content?.font);
    }
  },
};
